import { IErrorModel } from "../../types/error/IErrorModel"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { IDownloadResponse } from "../../types/IDownloadResponse"

export function removeItem<T>(arr: Array<T>, value: T): Array<T> {
  const index = arr.indexOf(value)
  if (index > -1) {
    arr.splice(index, 1)
  }
  return arr
}

export function getDateTime(timestamp: string) {
  try {
    let lang = localStorage.getItem("i18nextLng")
    if (!lang) lang = "en"
    const date = new Date(timestamp)
    const year = new Intl.DateTimeFormat(lang, { year: "numeric" }).format(date)
    const month = new Intl.DateTimeFormat(lang, { month: "short" }).format(date)
    let day = new Intl.DateTimeFormat(lang, { day: "2-digit" }).format(date)
    if (new Date().getDate() - date.getDate() >= 1) {
      return `${day} ${lang === "ru" ? month.substring(0, 3) : month} ${year} ${date.getHours()}:${date.getMinutes()}`
    } else {
      return `${padTo2Digits(date.getHours())}:${padTo2Digits(date.getMinutes())}`
    }
  } catch (e) {
    return ""
  }
}

export function getFormattedDate(timestamp: string) {
  const date = new Date(timestamp)
  return `${padTo2Digits(date.getDate())}.${padTo2Digits(date.getMonth() + 1)}.${padTo2Digits(date.getFullYear())}`
}

export function getMskTime(timestamp: string) {
  return new Date(timestamp)
    .toLocaleString("ru-RU", { timeZone: "Europe/Moscow" })
    .replace(",", "<br/>")
    .split(":")
    .slice(0, -1)
    .toString()
    .replace(",", ":")
}

export function getFieldError(errorModel: IErrorModel | undefined, fieldName: string) {
  if (errorModel && errorModel.fieldErrors.filter(fe => fe.field === fieldName).length > 0) {
    return errorModel.fieldErrors.filter(fe => fe.field === fieldName)[0].defaultMessage
  }
}

export function spacedNum(x: string | number | undefined) {
  if (!x) return "0"
  let parts = x.toString().split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  return parts.join(".")
}

export function dateToInputString(date: Date) {
  let day = ("0" + date.getDate()).slice(-2)
  let month = ("0" + (date.getMonth() + 1)).slice(-2)
  return date.getFullYear() + "-" + month + "-" + day
}

export function getMime(ext: string) {
  switch (ext) {
    case "xls":
      return "application/vnd.ms-excel"
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    case "doc":
      return "application/msword"
    case "txt":
      return "text/plain"
    case "pdf":
      return "application/pdf"
  }
}

export function download(id: string | undefined, type: string) {
  if (!id) return
  // TrinityAPI.downloadFile(id, type, response => {
  //   const data: IDownloadResponse = response.data
  //   const a = document.createElement("a")
  //   a.download = `${data.name}.${data.extension}`
  //   a.href = `data:${getMime(data.extension)};base64,${data.b64}`
  //   a.click()
  // })
  TrinityAPI.downloadFile(id, type, response => {
    const data: IDownloadResponse = response.data

    const byteCharacters = atob(data.b64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)

    const blob = new Blob([byteArray], { type: getMime(data.extension) })
    const blobUrl = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = blobUrl
    a.download = `${data.name}.${data.extension}`
    a.click()

    URL.revokeObjectURL(blobUrl)
  })
}

export const round2Digits = (val: string | number | undefined): number => {
  return Math.round((Number(val) + Number.EPSILON) * 100) / 100
}

export const round4Digits = (val: string | number | undefined): number => {
  return Math.round((Number(val) + Number.EPSILON) * 10000) / 10000
}

function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0")
}
